<footer>
  <section id="footer">
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-mb-12">
            <img src="/assets/svg/investing-for-catholics-logo.svg" width="200" height="50"  alt="Investing for Catholics Logo">
            <div class="textwidget">

            </div>
          </div>

          <div class="col-lg-9 col-xs-12">
            <ul class="short-menu">
              <li><a routerLink="/disclosures">Disclosures</a></li>
              <li><a routerLink="/glossary">Glossary</a></li>
              <li><a routerLink="/disclosures/index-data/">Backtested Performance Info</a></li>
              <li><a routerLink="/disclosures">Terms of Use</a></li>
              <li><a routerLink="/open-account">Contact</a></li>

            </ul>

          </div>

        </div>
        <div class="copyright">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="site-info float-start">
                  <p><small>© {{currentYear}} - Investing for Catholics, a division of Index Fund Advisors, Inc. | 19200
                      Von Karman Ave., Suite 150, Irvine, CA 92612</small></p>
                  <p><small>Mary Brunson, Senior Vice President Toll Free: <a href="tel:+18888155025" aria-label="Call Investing for Catholics at 888.815.5025">888-815-5025</a>
                    </small></p>
                  <p><small style="font-style: italic;">
                      The information provided on this website is for general educational purposes only and should not be construed as personalized investment, legal, or tax advice, or as a recommendation to buy or sell any security or adopt any particular investment strategy. Investing involves risk, including the possible loss of principal, and no investment strategy can guarantee results. See more important disclosures at <a href="https://www.investingforcatholics.com/disclosures">https://www.investingforcatholics.com/disclosures</a>.
                  </small></p>
                  <p><small style="font-style: italic;">
                    The data provided in charts referring to IFC Index Portfolios is hypothetical back tested performance and is not actual client performance. Performance data for the IFC Index Portfolios is shown net of IFC’s highest advisory fee and the underlying fund expenses. IFC Indexes, when shown individually, do not reflect a deduction of advisory fees. None of the data reflects trading costs or taxes, which would have lowered performance by these costs.
                  </small></p>
                  <p><small style="font-style: italic;">
                    Quotes and likenesses of notables referenced on this website are provided for information purposes only and should not be construed as an endorsement, recommendation or guarantee of any particular financial product, service or advisor.
                  </small></p>
                </div>
                <div class="float-end">
                  <ul class="footer-social">
                    <li><a class="facebook" href="https://www.facebook.com/ifadotcom/" target="_blank" title="Facebook"
                        alt="Facebook">
                        <app-facebook></app-facebook>
                      </a></li>
                    <li><a class="twitter" href="https://twitter.com/IFAdotcom" title="Twitter" alt="Twitter">
                        <app-twitter></app-twitter>
                      </a></li>
                    <li><a class="linkedin" href="https://linkedin.com/company/index-funds-advisors-inc-"
                        title="LinkedIn" alt="LinkedIn">
                        <app-linkedin></app-linkedin>
                      </a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</footer>